import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import axios from "axios";
import { baseServiceUrl, urls } from "../../environment";
import toast from "react-hot-toast";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { Button, IconButton } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import useUserStore from "../../stores/useUserStores";
const ExamList = () => {
  const { token, setLoading } = useUserStore();
  const [tests, setTests] = useState<any[]>([]);
  const navigate = useNavigate();
  const errornotify = (msg: any) => toast.error(msg);
  const addNew = () => {
    navigate("/admin-dashboard/create-test");
  };
  const onClickView = (value: any) => {};
  const columns: GridColDef[] = [
    {
      field: "category",
      headerName: "Category",
      flex: 1,
    },
    {
      field: "title",
      headerName: "Test Name",
      flex: 1.5,
    },
    {
      field: "total_marks",
      headerName: "Total Mark",
      flex: 1,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "total_questions",
      headerName: "No of Questions",
      flex: 1,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "duration",
      headerName: "Duration (Min)",
      flex: 1,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "Action",
      headerName: "Action",
      sortable: false,
      renderCell: ({ row }: any) => {
        return (
          <IconButton aria-label="delete" onClick={() => onClickView(row)}>
            <InfoIcon />
          </IconButton>
        );
      },
    },
  ];
  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const response = await axios.get(baseServiceUrl + urls.getAllExamUrl, {
          headers: {
            Authorization: "Bearer " + token,
          },
        });
        if (response.data) {
          setTests(response.data);
        }

        setLoading(false);
      } catch (err: any) {
        setLoading(false);
        errornotify(
          err?.response?.data?.message || "Error encounter. Please try again."
        );
      }
    })();
  }, []);
  return (
    <section
      id="sample-paper"
      className={` flex flex-col items-center justify-center`}
    >
      <div className="container w-full py-4 lg:w-[90%] md:w-[100%] mx-auto">
        <div className="bg-white rounded shadow-lg p-4 px-4 md:p-8 flex flex-col">
          <div className="flex flex-row items-center justify-between">
            <p className="text-2xl font-semibold mb-5">All Tests</p>
            <div>
              <button
                type="button"
                onClick={addNew}
                className={`w-[150px] bg-[#2d69eb] hover:bg-[#2563EB] text-white font-medium rounded-lg text-sm px-5 py-2.5 mt-[10px] text-center`}
              >
                + Add New Test
              </button>
            </div>
          </div>
        </div>
        <div className="mb-6">
          <DataGrid
            sx={{
              ".MuiDataGrid-columnHeader": {
                backgroundColor: "#E5E7EB",
              },
              ".MuiDataGrid-columnHeaderTitle": {
                fontWeight: "500",
                fontSize: 16,
                color: "#23304a",
              },
            }}
            rows={tests}
            columns={columns}
            initialState={{
              pagination: {
                paginationModel: { page: 0, pageSize: 5 },
              },
            }}
            pageSizeOptions={[5, 10]}
          />
        </div>
      </div>
    </section>
  );
};

export default ExamList;
